import { Heading, Typography } from "@sidelinesports/fan-design-system";
import type { FC } from "react";

export const H1: FC = (props) => <Heading level={1} {...props} />;

export const H2: FC = (props) => <Heading level={2} {...props} />;

export const H3: FC = (props) => <Heading level={3} {...props} />;

export const H4: FC = (props) => <Heading level={4} {...props} />;

export const H5: FC = (props) => <Heading level={5} {...props} />;

export const H6: FC = (props) => <Heading level={6} {...props} />;

export const P: FC = (props) => <Typography size="md" {...props} />;
